export const USE_ANOTHER_PAYMENT_METHOD_ERROR = 'Transaction failed. Please verify the card details are correct or use a different card.'
export const GENERIC_PAYMENT_ERROR = 'Transaction failed.'
